import { Button, styled } from "@mui/material";

export const StyledFormikActions = {
    Container: styled("div")(({ theme }) => ({
        margin: 5,
    })),
    CancelButton: styled(Button)(({ theme }) => ({
        marginRight: 10,
    })),
};
